<div
  class="app-message-popup"
  [ngClass]="'popup-' + type"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="title">

  <button
    *ngIf="closable"
    type="button"
    class="popup-close"
    aria-label="Close popup"
    (click)="close()">

    <i class="bi bi-x-lg"></i>
  </button>

  <div class="popup-icon">
    <i [class]="iconClass"></i>
  </div>

  <h4 class="popup-title">
    {{ title }}
  </h4>

  <p class="popup-message">
    {{ message }}
  </p>

  <!-- Typed confirmation for destructive actions -->
  <div
    *ngIf="requireTextConfirmation"
    class="confirmation-input-section">

    <label
      class="confirmation-input-label"
      for="popupConfirmationInput">

      {{
        inputLabel ||
        'Type the confirmation text below to continue'
      }}
    </label>

    <div class="confirmation-required-text">
      Type

      <strong>
        {{ expectedText }}
      </strong>

      to confirm.
    </div>

    <input
      id="popupConfirmationInput"
      type="text"
      class="confirmation-input"
      [class.confirmation-input-valid]="
        confirmationMatches
      "
      [class.confirmation-input-invalid]="
        confirmationValue &&
        !confirmationMatches
      "
      [value]="confirmationValue"
      [placeholder]="
        inputPlaceholder ||
        expectedText
      "
      autocomplete="off"
      autocapitalize="characters"
      spellcheck="false"
      (input)="onConfirmationInput($event)"
      (keydown.enter)="confirm()"
    />

    <small
      *ngIf="
        confirmationValue &&
        !confirmationMatches
      "
      class="confirmation-error">

      <i class="bi bi-exclamation-circle"></i>

      Enter
      <strong>{{ expectedText }}</strong>
      exactly to continue.
    </small>

    <small
      *ngIf="confirmationMatches"
      class="confirmation-success">

      <i class="bi bi-check-circle"></i>

      Confirmation text matched.
    </small>
  </div>

  <div class="popup-actions">
    <button
      *ngIf="showCancel"
      type="button"
      class="popup-button popup-cancel-button"
      (click)="cancel()">

      {{ cancelText }}
    </button>

    <button
      type="button"
      class="popup-button popup-confirm-button"
      [disabled]="confirmDisabled"
      (click)="confirm()">

      {{ confirmText }}
    </button>
  </div>
</div>